import { render, staticRenderFns } from "./ConversionSettingsEdit.vue?vue&type=template&id=75dc3f3c&scoped=true"
import script from "./ConversionSettingsEdit.vue?vue&type=script&lang=ts"
export * from "./ConversionSettingsEdit.vue?vue&type=script&lang=ts"
import style0 from "./ConversionSettingsEdit.vue?vue&type=style&index=0&id=75dc3f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc3f3c",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/conversion/conversion-settings-edit.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2Fconversion%2FConversionSettingsEdit.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports